const graphIds = Object.freeze([
    720,
    721
])

export { graphIds }